@link fn getScissor(value: vec4<f32>) -> vec4<f32>;

@export fn getPositionScissor(position: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32> {
  return getScissor(position);
};

@export fn getUVScissor(position: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32> {
  return getScissor(uv);
};

@export fn getSTScissor(position: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32> {
  return getScissor(st);
};
